import React from 'react';
import { Star } from 'lucide-react';
import { customerReviews } from '../data/mockData';
import { Card, CardContent } from './ui/card';

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Customer <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500">Reviews</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See what our customers are saying about their dining experience at Ambarsariya
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {customerReviews.slice(0, 6).map((review) => (
            <Card
              key={review.id}
              className="border-2 border-yellow-200 hover:border-yellow-400 transition-all shadow-md hover:shadow-xl group"
            >
              <CardContent className="pt-6">
                {/* Stars */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(review.rating)].map((_, index) => (
                    <Star
                      key={index}
                      className="w-5 h-5 fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "{review.review}"
                </p>

                {/* Reviewer Info */}
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-bold text-gray-800">{review.name}</p>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-yellow-100 to-pink-100 rounded-2xl p-8 inline-block">
            <p className="text-gray-800 font-semibold text-lg mb-2">
              Join hundreds of satisfied customers!
            </p>
            <p className="text-gray-600">
              Visit us at VR Nagpur and experience authentic North Indian cuisine
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
